import React from "react";
import makeCancelable from "./make-promise-cancelable";

const states = {
  loading: "loading",
  rejected: "rejected",
  resolved: "resolved",
};

const reducer = (state, action) => {
  switch (action.type) {
    case states.loading:
      return {
        error: undefined,
        result: undefined,
        loading: true,
      };

    case states.resolved:
      return {
        error: undefined,
        result: action.payload,
        loading: false,
      };

    case states.rejected:
      return {
        error: action.payload,
        result: undefined,
        loading: false,
      };

    default:
      return state;
  }
};
const initial_state = {
  error: undefined,
  result: undefined,
  loading: false,
};

const usePromiseResolver = (promiseFn, dependencies) => {
  const [{ loading, result, error }, dispatch] = React.useReducer(reducer, initial_state);
  const lastPromise = React.useRef();

  const cancelPromise = () => {
    if (lastPromise && lastPromise.current && typeof lastPromise.current.cancel === "function") {
      lastPromise.current.cancel();
    }
  };
  const resolvePromise = () => {
    dispatch({ type: states.loading });

    cancelPromise();

    lastPromise.current = makeCancelable(promiseFn());
    lastPromise.current.promise
      .then(res => {
        dispatch({ type: states.resolved, payload: res });
      })
      .catch(e => {
        if (!e.isCanceled) {
          dispatch({ type: states.rejected, payload: error });
        }
      });
  };

  React.useEffect(resolvePromise, dependencies);

  return [result, loading, error, resolvePromise];
};

export default usePromiseResolver;
